<!--
 * @Author: 张韶杰
 * @Date: 2024-10-31 11:14:34
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2026-07-20 11:36:43
 * @FilePath: \ysz_web_international_h5\src\App.vue
 * @Description: 
 * 
-->
<template>
  <div id="app">
    <common-top v-if="$route.meta.commonTop" :showSearch="!$route.meta.noSearch"></common-top>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    <Footer v-if="$route.meta.footer"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/footer.vue'
import CommonTop from '@/components/commonTop.vue'
export default {
  name: 'App',
  components: {
    CommonTop,
    Footer
  },
  data() {
    return {
    }
  },
  mounted() {
  },
}
</script>

<style>
.ysz-ueditor-title-three-zsj::before {
  content: "";
  display: inline-block;
  width: 0.433333rem;
  height: 0.433333rem;
  background-color: #000;
  border-radius: 50%;
  margin: 0 0.3rem 0 0.6rem;
}
/* p:has(.ysz-ueditor-content) {
    margin: 0;
    padding: 0;
} */

* {
  box-sizing: border-box;

}

.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
